
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import { MuxStreamTypes } from '~/types/mux-player';
import {
  SanityDocumentSchema,
  ISanityDocuments,
} from '~/types/sanity-documents';
import PageHeroContainer from '~/components/UIComponents/PageHeroContainer.vue';
import VideoPlayer from '~/components/Player/VideoPlayer.vue';
import SanityReference from '~/components/Sanity/SanityReference.vue';
import CountdownTimer from '~/components/Promotions/CountdownTimer.vue';

@Component({
  components: {
    CountdownTimer,
    PageHeroContainer,
    SanityReference,
    VideoPlayer,
  },
})
export default class LiveStreamHero extends Vue {
  @Prop(Object)
  readonly doc!: ISanityDocuments[SanityDocumentSchema.LIVE_STREAM];

  streamType = MuxStreamTypes.LIVE;
  showCountdown = true;
  schemas = SanityDocumentSchema;

  get backgroundImage() {
    return !this.doc?.pageHeroImage
      ? undefined
      : this.$sanityImage.urlFor(this.doc.pageHeroImage).width(1920).url();
  }

  get genres() {
    return this.doc?.genres || [];
  }

  get hasLiveStreamStarted() {
    if (!this.releaseDate) {
      return false;
    }

    const now = new Date().getTime();
    return this.startTime <= now;
  }

  get mainContent():
    | ISanityDocuments[SanityDocumentSchema.VIDEO_LIVE_STREAM]
    | undefined {
    if (!this.doc?.content?._ref) {
      return;
    }

    return this.$sanityLookup.getDocumentFromId({
      _id: this.doc.content._ref,
      _type: this.schemas.VIDEO_LIVE_STREAM,
    })?.data as ISanityDocuments[SanityDocumentSchema.VIDEO_LIVE_STREAM];
  }

  get releaseDate() {
    return this.doc?.releaseDate || undefined;
  }

  get shouldShowCountdownMessage() {
    return this.releaseDate && this.showCountdown && !this.hasLiveStreamStarted;
  }

  get startTime() {
    return this.releaseDate ? new Date(this.releaseDate).getTime() : 0;
  }

  get title() {
    return (
      this.doc?.title || this.$t('components.live.liveStreamHero.untitled')
    );
  }

  async handleCountdownExpired() {
    this.showCountdown = false;
  }
}
